import { render, staticRenderFns } from "./LabelModuleSelector.vue?vue&type=template&id=33608826&scoped=true&"
import script from "./LabelModuleSelector.vue?vue&type=script&lang=js&"
export * from "./LabelModuleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33608826",
  null
  
)

export default component.exports